import { event as trackGtagEvent } from 'vue-gtag'

const ARTICLE_LINK_EVENT_NAME = 'partner_click'

export function trackArticleLinkConversion(clickEvent, url) {
    if (!url) {
        return
    }

    const target = clickEvent?.currentTarget?.getAttribute('target') || '_self'
    const shouldDelayNavigation = target !== '_blank'

    const navigate = () => {
        window.location.assign(url)
    }

    if (shouldDelayNavigation) {
        clickEvent.preventDefault()
    }

    try {
        trackGtagEvent(ARTICLE_LINK_EVENT_NAME, {
            link_url: url,
            link_target: target,
        })

        if (shouldDelayNavigation) {
            // Fallback navigation keeps the link working even if the callback never fires.
            window.setTimeout(navigate, 1200)
        }
    } catch {
        if (shouldDelayNavigation) {
            navigate()
        }
    }
}